import React from 'react';
import PropTypes from 'prop-types';
import { LegacySingleChoiceQuestion } from './LegacySingleChoiceQuestion';

// Only used for App 1.0 Sample Question Component

const LegacyQuestion = ({
  showResponseCorrectness = false,
  canShowAnswer = false,
  ...props
}) => {
  const { question } = props;
  const getPeerComparisonPercents = (sampleQuestion) => {
    if (sampleQuestion.peer_response_count < 10) return null;
    const percents = {};
    sampleQuestion.answers.forEach((answer) => {
      percents[answer.choice] = (answer.peer_response_count || 0) / question.peer_response_count;
    });
    return percents;
  };

  const peerComparisonPercents = getPeerComparisonPercents(question);

  return (
    <LegacySingleChoiceQuestion
      {...props}
      showResponseCorrectness={showResponseCorrectness}
      canShowAnswer={canShowAnswer}
      peerComparisonPercents={peerComparisonPercents}
    />
  );
};

LegacyQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  showResponseCorrectness: PropTypes.bool,
  canShowAnswer: PropTypes.bool,
  selectedAnswer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.number)
  ]),
  onChangeAnswer: PropTypes.func,
  onClickShowAnswer: PropTypes.func,
  onClickAnswer: PropTypes.func,
  disableAnswerSelection: PropTypes.bool
};

export default LegacyQuestion;
